import { executePost } from '../common/apiCaller'
import { PostFacilitySearchSettingMstsDto, PostFacilitySearchSettingMstsInputDto } from '../dto/facilitySearchSettingMstsDto'

const apiName = 'public'
const apiPath = '/facility-search-setting-mst'

export const executePostFacilitySearchSettingMsts = (input?: PostFacilitySearchSettingMstsInputDto) => {
    return executePost<PostFacilitySearchSettingMstsDto[]>(apiName, apiPath, input)
}
  